<template lang="html">
	<div class="upload_wrap">
		<el-upload class="avatar-uploader" action="" :show-file-list="false" :http-request="fnUploadRequest" :before-upload="before_upload">
			<img v-if="value" :src="value" class="avatar">
			<i v-else class="el-icon-plus avatar-uploader-icon"></i>
		</el-upload>
	</div>
</template>
<script>
import { uploadOSS,deleteOSS } from '@/utils/oss';
// import {matchType} from '@/utils/matchType.js'
export default {
	name: 'upload_image',
	data() {
		return {
			loading:null,
		}
	},
	model: {
		prop: 'value',
		event: 'change'
	},
	props: {
		value: {
			type: String,
			default: ''
		},
		file_name: {
			type: String,
			default: 'image' //file video
		}
	},
	methods: {
		async fnUploadRequest(options){
			try {
				let file = options.file;
				let res = await uploadOSS(this.file_name+'/'+file.name,file);
	            this.$emit('callback', res);
				this.$message.success("上传成功！");
				this.loading.close();
			} catch (e) {
				this.$message.error('上传失败！');
				this.loading.close();
			}
		},
		before_upload(data){
			var name=['tif','jpeg','jpg','png','mp4','mov','avi'];
			var file_name=data.name.split('.')[1];
			if(name.indexOf(file_name)==-1){
				this.$message.error('上传文件后缀(jpg/png/tif)或(mp4/mov/avi)');
				return false
			}
			this.loading = this.$loading({
				lock: true,
				text: 'Loading',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
		},
	}
}
</script>
<style lang="css">
.upload_wrap .avatar-uploader .el-upload {
	border: 1px dashed #d9d9d9;
	border-radius: 6px;
	cursor: pointer;
	display: block;
	width: 100px;
	height: 100px;
	line-height: 100px!important;
	font-size: 28px;
	color: #8c939d;
	text-align: center;
}
.upload_wrap .avatar-uploader .el-upload .el-upload__input {
    display: none!important;
}
.upload_wrap .avatar-uploader .el-upload:hover {
	border-color: #409EFF;
}
.upload_wrap .avatar-uploader .el-upload .avatar{
	width: 100%;
	height: 100%;
	object-fit: contain;
}
.upload_wrap .avatar-uploader .avatar-uploader-icon {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/upload.vue